module.exports = __webpack_public_path__ + "media/images/emblems/Bauma-blazon-c61a2442d2745070a40ffa7db00485d3.svg";